import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection, doc } from 'firebase/firestore'

export default class FormField extends BaseModel {
  constructor(id: string, section: string) {
    super(collection(doc(collection(doc(collection(db, 'forms'), id), 'sections'), section), 'fields'))
  }
}
